// extracted by mini-css-extract-plugin
export default {"draftReportHeader":"DraftReportHeader_draftReportHeader__Nv8Pv","headerCrumbs":"DraftReportHeader_headerCrumbs__OzWjR"};